var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFixed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ListDashes")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-Box_\\u7EA2\\u5305\\u5386\\u53F2",
    transform: "translate(-696.000000, -266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ListDashes",
    transform: "translate(692.000000, 259.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,8 C11,7.44771525 11.4477153,7 12,7 L27,7 C27.5522847,7 28,7.44771525 28,8 C28,8.55228475 27.5522847,9 27,9 L12,9 C11.4477153,9 11,8.55228475 11,8 Z M27,15 L12,15 C11.4477153,15 11,15.4477153 11,16 C11,16.5522847 11.4477153,17 12,17 L27,17 C27.5522847,17 28,16.5522847 28,16 C28,15.4477153 27.5522847,15 27,15 Z M27,23 L12,23 C11.4477153,23 11,23.4477153 11,24 C11,24.5522847 11.4477153,25 12,25 L27,25 C27.5522847,25 28,24.5522847 28,24 C28,23.4477153 27.5522847,23 27,23 Z M7,7 L5,7 C4.44771525,7 4,7.44771525 4,8 C4,8.55228475 4.44771525,9 5,9 L7,9 C7.55228475,9 8,8.55228475 8,8 C8,7.44771525 7.55228475,7 7,7 Z M7,15 L5,15 C4.44771525,15 4,15.4477153 4,16 C4,16.5522847 4.44771525,17 5,17 L7,17 C7.55228475,17 8,16.5522847 8,16 C8,15.4477153 7.55228475,15 7,15 Z M7,23 L5,23 C4.44771525,23 4,23.4477153 4,24 C4,24.5522847 4.44771525,25 5,25 L7,25 C7.55228475,25 8,24.5522847 8,24 C8,23.4477153 7.55228475,23 7,23 Z",
    id: "\\u5F62\\u72B6",
    fill: "#281071",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFixed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_fixed.8085620a.svg";
export { ForwardRef as ReactComponent };